// Colours and glyphs shared by the 3D markers and the UI legends.
// Categorical hues come from one validated palette (dark-surface steps), assigned in a fixed order.
export const SLOTS = ['#3987e5', '#d95926', '#199e70', '#c98500', '#d55181', '#008300', '#9085e9', '#e66767'];
export const OTHER = '#8c8b82';

export const FEATURE_KINDS = {
  sinkhole: { label: 'Sinkhole', color: '#3987e5', glyph: 'S' },
  dig: { label: 'Dig site', color: '#c98500', glyph: 'D' },
  entrance: { label: 'Entrance', color: '#199e70', glyph: 'E' },
  spring: { label: 'Spring / resurgence', color: '#9085e9', glyph: 'R' },
  swallet: { label: 'Swallet / insurgence', color: '#d55181', glyph: 'W' },
  pit: { label: 'Pit', color: '#e66767', glyph: 'P' },
  other: { label: 'Other', color: OTHER, glyph: '•' },
};

export const OBS_CATEGORIES = {
  biology: { label: 'Biology', color: '#199e70', glyph: 'B' },
  hydrology: { label: 'Hydrology', color: '#3987e5', glyph: 'H' },
  geology: { label: 'Geology', color: '#c98500', glyph: 'G' },
  paleontology: { label: 'Paleontology', color: '#9085e9', glyph: 'F' },
  archaeology: { label: 'Archaeology', color: '#d55181', glyph: 'A' },
  formation: { label: 'Formations', color: '#9085e9', glyph: 'f' },
  hazard: { label: 'Hazard', color: '#e66767', glyph: '!' },
  climate: { label: 'Air / climate', color: '#3987e5', glyph: '~' },
  conservation: { label: 'Conservation', color: '#199e70', glyph: 'C' },
  other: { label: 'Other', color: OTHER, glyph: '•' },
};

export const STUDY_KINDS = {
  dye_trace: { label: 'Dye trace', color: '#199e70' },
  air_tracing: { label: 'Air tracing', color: '#9085e9' },
  water_quality: { label: 'Water quality', color: '#3987e5' },
  other: { label: 'Other study', color: OTHER },
};

export const RESULTS = {
  positive: { label: 'Detected', color: '#d55181' },
  negative: { label: 'Not detected', color: OTHER },
  inconclusive: { label: 'Inconclusive', color: '#c98500' },
};

// Passage depth ramp: one hue, light (near the surface) -> dark (deep)
export const DEPTH_RAMP = [[0, '#ffe3d1'], [15, '#fbb690'], [35, '#f28556'], [60, '#dd5f2b'], [90, '#b8471a'], [130, '#8a3311'], [170, '#6b270c']];
export const ABOVE_GROUND = '#e87ba4';
export const MAP_INK = '#f5e8d1';

// points of interest: each category has its own marker (shape, colour, glyph or pictogram); see icons.js
export const RECORD_STYLE = { color: '#d9a441', glyph: 'H', shape: 'hex', label: 'Historic record' };
const POI_NONE = { color: '#8c8b82', glyph: '•', shape: 'circle', label: 'Point of interest' };
export const poiCategories = new Map();          // id -> {name, color, shape, icon}
export function setPoiCategories(list) {
  poiCategories.clear();
  for (const c of list || []) if (c.id != null) poiCategories.set(c.id, c);
}
export function poiStyle(catId) {
  const c = poiCategories.get(catId);
  return c ? { color: c.color, glyph: c.icon, shape: c.shape, label: c.name } : POI_NONE;
}

export function placeStyle(p) {
  if (p.type === 'record') return poiCategories.size || p.cat == null ? poiStyle(p.cat) : RECORD_STYLE;
  if (p.type === 'feature') return FEATURE_KINDS[p.kind] || FEATURE_KINDS.other;
  if (p.type === 'observation') return OBS_CATEGORIES[p.kind] || OBS_CATEGORIES.other;
  if (p.type === 'study_point') {
    if (p.kind === 'source') return { color: (STUDY_KINDS[p.study_kind] || STUDY_KINDS.other).color, glyph: '▲', label: 'Source' };
    return { color: (RESULTS[p.result] || { color: '#c3c2b7' }).color, glyph: p.result === 'positive' ? '✓' : p.result === 'negative' ? '×' : '?', label: 'Receptor' };
  }
  return { color: OTHER, glyph: '•' };
}

export const fmtM = (m) => (m == null ? '—' : `${m.toFixed(1)} m · ${(m / 0.3048).toFixed(0)} ft`);
